import { Effect } from "../../../redux/types/effect.type";
import { ActionsObservable } from "redux-observable";
import { catchError, filter, map, mergeMap } from "rxjs/operators";
import { isActionType } from "../../../redux/action.functions";
import * as actions from "./product-search-shared.actions";
import * as CategoryService from "../services/product-category-search.service";
import * as SubCategoryService from "../services/product-subcategory-search.service";
import { of } from "rxjs";
import { ProductSearchSharedActions } from "./product-search-shared.actions";

const searchCategories: Effect = (action$: ActionsObservable<any>) =>
  action$.pipe(
    filter(isActionType(ProductSearchSharedActions.SearchCategory)),
    map((action) => action.payload),
    mergeMap((searchText) =>
      CategoryService.searchProductCategories(searchText).pipe(
        map((result) => actions.searchCategorySuccess(result)),
        catchError((error) => of(actions.searchCategoryFailure(error)))
      )
    )
  );

const searchSubcategories: Effect = (action$: ActionsObservable<any>) =>
  action$.pipe(
    filter(isActionType(ProductSearchSharedActions.SearchSubcategory)),
    map((action) => action.payload),
    mergeMap((searchText) =>
      SubCategoryService.searchProductSubcategories(searchText).pipe(
        map((result) => actions.searchSubcategorySuccess(result)),
        catchError((error) => of(actions.searchSubcategoryFailure(error)))
      )
    )
  );

export const ProductSearchSharedEffects = [searchCategories, searchSubcategories];
